
/**
 * @deprecated use same function from '@rchh/lowcode-utils' instead
 */
export function isI18nData(obj: any): boolean {
  return obj && obj.type === 'i18n';
}
